import { removeMark } from '@atlaskit/editor-common/mark';
import { ACTIONS, pluginKey } from '../pm-plugins/main';
export var removeColor = function removeColor(_ref) {
  var tr = _ref.tr;
  var textColor = tr.doc.type.schema.marks.textColor;
  removeMark(textColor)({
    tr: tr
  });
  tr.setMeta(pluginKey, {
    action: ACTIONS.RESET_COLOR
  });
  return tr;
};